import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "checkbox-filter" }
const _hoisted_2 = { class: "checkbox-filter__trigger-label" }
const _hoisted_3 = { class: "checkbox-filter__trigger-value" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "checkbox-filter__options" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none"
}
const _hoisted_8 = ["checked"]
const _hoisted_9 = { class: "checkbox-filter__option-label" }

import { ref, computed, watch } from 'vue';
import Popover from 'primevue/popover';

interface Props {
    modelValue: string[]
    options: string[]
    label?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxFilter',
  props: {
    modelValue: {},
    options: {},
    label: { default: 'Filter' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const emit = __emit;

const popoverRef = ref();

const normalizedSelected = computed(() => props.modelValue.filter((value) => props.options.includes(value)));
const allSelected = computed(() => props.options.length > 0 && normalizedSelected.value.length === props.options.length);
// Selections are staged in a draft so the panel filters and closes only on Apply.
const draft = ref<string[]>([]);
const hasSelection = computed(() => draft.value.length > 0);

function syncDraft() {
    draft.value = [...normalizedSelected.value];
}

const triggerValue = computed(() => {
    if (allSelected.value) return 'All';
    if (normalizedSelected.value.length === 0) return 'All';
    return `${normalizedSelected.value.length} of ${props.options.length}`;
});

function isChecked(option: string): boolean {
    return draft.value.includes(option);
}

function toggleOption(option: string) {
    draft.value = draft.value.includes(option)
        ? draft.value.filter((value) => value !== option)
        : [...draft.value, option];
}

function clearSelection() {
    draft.value = [];
}

function applySelection() {
    emit('update:modelValue', [...draft.value]);
    popoverRef.value?.hide();
}

function cancelSelection() {
    syncDraft();
    popoverRef.value?.hide();
}

// Refreshed before the panel opens rather than on the popover's show event, so the first frame
// already holds the applied selection.
function togglePanel(event: MouseEvent) {
    if (!popoverRef.value?.visible) syncDraft();
    popoverRef.value?.toggle(event);
}

watch(
    () => props.options,
    (options) => {
        const next = props.modelValue.filter((value) => options.includes(value));
        if (next.length !== props.modelValue.length) {
            emit('update:modelValue', next);
        }
    },
    { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "checkbox-filter__trigger",
      type: "button",
      "aria-haspopup": "dialog",
      onClick: togglePanel
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label) + ":", 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(triggerValue.value), 1),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "checkbox-filter__trigger-chevron",
        width: "12",
        height: "7",
        viewBox: "0 0 12 7",
        fill: "none",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          d: "M1 1L6 6L11 1",
          stroke: "currentColor",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1))
    ]),
    _createVNode(_unref(Popover), {
      ref_key: "popoverRef",
      ref: popoverRef,
      pt: { root: { class: 'checkbox-filter-popover popover-align-end' } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "checkbox-filter__clear",
          disabled: !hasSelection.value,
          onClick: clearSelection
        }, " Clear All / Display All ", 8, _hoisted_4),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "checkbox-filter__separator" }, null, -1)),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
            return (_openBlock(), _createElementBlock("label", {
              key: option,
              class: "checkbox-filter__option",
              onClick: _withModifiers(($event: any) => (toggleOption(option)), ["prevent"])
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["checkbox-filter__checkmark", { 'checkbox-filter__checkmark--checked': isChecked(option) }])
              }, [
                (isChecked(option))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("path", {
                        d: "M1 4L3.5 6.5L9 1",
                        stroke: "white",
                        "stroke-width": "1.8",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, null, -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("input", {
                class: "checkbox-filter__input",
                type: "checkbox",
                tabindex: "-1",
                checked: isChecked(option)
              }, null, 8, _hoisted_8),
              _createElementVNode("span", _hoisted_9, _toDisplayString(option), 1)
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", { class: "checkbox-filter__footer" }, [
          _createElementVNode("button", {
            type: "button",
            class: "checkbox-filter__footer-action checkbox-filter__footer-action--secondary",
            onClick: cancelSelection
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "checkbox-filter__footer-action checkbox-filter__footer-action--primary",
            onClick: applySelection
          }, " Apply ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})